import { WidgetsTypeEnum } from 'src/app/enums/widgets/widgets-type.enum';
import { WidgetsAbstract } from '../../abstract/widgets/widgets.abstract';
import { WidgetsFieldModel } from './widgets-field.model';

export class WidgetsInputModel extends WidgetsFieldModel {
  readonly widgetType: WidgetsTypeEnum = WidgetsTypeEnum.INPUT;
  name: string = 'Input';
  readonly badge: string = 'IN';
  type: string = 'input';
  suffix?: boolean = false;
  prefix?: boolean; //optional;
  isPasteEnabled: boolean = false;
  suffixText?: string = '';
  prefixText?: string = '';

  // Number
  validateOnBlur: boolean = false;
  isNumeric: boolean = false;
  isDecimal?: boolean = false;    // Allows decimal sign. Default: no (integer)
  isInclusive?: boolean;          // Considers min/max validation values to be inclusive/exclusive
  isPercentage?: boolean = false; // Treat the input like a percenatage
  minNum?: number;
  maxNum?: number;
  isMinCurrentYear?: boolean; // Whatever min contains it is interpreted as current year
  isMaxCurrentYear?: boolean; // Whatever max contains it is interpreted as current year

  // Text
  minTextLength?: number;
  maxTextLength?: number;
  pattern?: string;
  readonly?: boolean;

  maxDecimalNum?: number;
  minDecimalNum?: number;
  commentFieldKeys: string[] = [];

  toJSON(): any {
    const extendedSpecificProperties = {
      suffix: this.suffix ? this.suffix : undefined,
      prefix: this.prefix ? this.prefix : undefined,
      suffixText: this.suffixText ? this.suffixText : undefined,
      prefixText: this.prefixText ? this.prefixText : undefined,
      isNumeric: this.isNumeric ? this.isNumeric : undefined,
      validateOnBlur: this.validateOnBlur ? this.validateOnBlur : undefined,
      isDecimal: this.isDecimal ? this.isDecimal : undefined,
      isInclusive: this.isInclusive ? this.isInclusive : undefined,
      isPercentage: this.isPercentage ? this.isPercentage : undefined,
      readonly: this.readonly ? this.readonly : undefined,
      minNum: (this.minNum === 0 || this.minNum) ? this.minNum : undefined,
      maxNum: this.maxNum ? this.maxNum : undefined,
      maxDecimalNum: this.maxDecimalNum ? this.maxDecimalNum : undefined,
      minDecimalNum: this.minDecimalNum ? this.minDecimalNum : undefined,
      isMinCurrentYear: this.isMinCurrentYear
        ? this.isMinCurrentYear
        : undefined,
      isMaxCurrentYear: this.isMaxCurrentYear
        ? this.isMaxCurrentYear
        : undefined,
      pattern: this.pattern ? this.pattern : undefined,
      minTextLength: this.minTextLength ? this.minTextLength : undefined,
      maxTextLength: this.maxTextLength ? this.maxTextLength : undefined,
      isPasteEnabled: this.isPasteEnabled ? this.isPasteEnabled : undefined,
      commentFieldKeys: this.commentFieldKeys ? this.commentFieldKeys : undefined,
    };

    return { ...super.toJSON(), ...extendedSpecificProperties };
  }

  /**
   * Clone this node from an origin.
   *
   * @param origin
   * @returns the cloned node
   */
  cloneFrom(origin: WidgetsInputModel): WidgetsInputModel {
    // Clone base class
    super.cloneFrom(origin);

    if (origin.type) {
      this.type = origin.type;
    } else {
      this.type = 'input';
    }

    // Model specific
    if (origin.suffix) {
      this.suffix = origin.suffix;
    }
    if (origin.prefix) {
      this.prefix = origin.prefix;
    }
    if (origin.suffixText) {
      this.suffixText = origin.suffixText;
    }
    if (origin.prefixText) {
      this.prefixText = origin.prefixText;
    }
    if (origin.isPasteEnabled) {
      this.isPasteEnabled = origin.isPasteEnabled;
    }

    // Numeric specific
    if (origin.isNumeric) {
      this.isNumeric = origin.isNumeric;
    }
    if (origin.validateOnBlur){
      this.validateOnBlur = origin.validateOnBlur;
    }
    if (origin.isDecimal) {
      this.isDecimal = origin.isDecimal;
    }
    if (origin.isInclusive) {
      this.isInclusive = origin.isInclusive;
    }
    if (origin.isPercentage) {
      this.isPercentage = origin.isPercentage;
    }
    if (origin.readonly) {
      this.readonly = origin.readonly;
    }
    if (origin.minNum !== undefined) {
      this.minNum = origin.minNum;
    }
    if (origin.maxNum !== undefined) {
      this.maxNum = origin.maxNum;
    }
    if (origin.maxDecimalNum !== undefined) {
      this.maxDecimalNum = origin.maxDecimalNum;
    }
    if (origin.maxDecimalNum !== undefined) {
      this.minDecimalNum = origin.minDecimalNum;
    }
    if (origin.isMinCurrentYear !== undefined) {
      this.isMinCurrentYear = origin.isMinCurrentYear;
    }
    if (origin.isMaxCurrentYear !== undefined) {
      this.isMaxCurrentYear = origin.isMaxCurrentYear;
    }

    // Text
    if (origin.maxTextLength) {
      this.maxTextLength = origin.maxTextLength;
    }
    if (origin.minTextLength) {
      this.minTextLength = origin.minTextLength;
    }
    if (origin.pattern) {
      this.pattern = origin.pattern;
    }
    if (origin.commentFieldKeys) {
      this.commentFieldKeys = origin.commentFieldKeys;
    }
    return this;
  }
}
